<template>
  <div>
    <section class="container-fluid">
      <div class="mainContainer">
        <div class="offtaker">

          <div class="offtaker__header">
            <h4 class="offtaker__header__title font-bold font-lg">My Crops</h4>
          </div>

          <div class="offtaker__body">
            <div class="slider">
              <div class="row">
                <crop-row v-for="(crop, i) in crops" :key="i" :crop="crop" />
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CropRow from '@/components/off-taker/mycrops/CropRow';

export default {
  data() {
    return {
      crops: [],
      gettingCrops: false
    };
  },
  computed: {
    // cropImg() {
    //   return this.crops.length !== 0 ? this.crops.images[0] ? ''
    // }
  },
  methods: {
    getCrops() {
      this.gettingCrops = true;
      this.$http.get("off_takers/crops?pageSize=5")
        .then(({ data }) => {
          this.crops = [...data.items];
        })
        .catch(err => {
          this.$toastr.error(err);
        })
        .finally(() => {
          this.gettingCrops = false
        })
    }
  },
  created() {
    this.getCrops();
  },
  components: {
    CropRow
  }
};
</script>
